import React from 'react';
import classes from './SkeletonText.module.css.js';
import { clsx } from 'clsx';
import '@styled-system/css';
import merge from 'deepmerge';
import { SkeletonBox } from '../../Skeleton/SkeletonBox.js';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SkeletonText = ({
  lines = 1,
  maxWidth,
  size = 'bodyMedium',
  className,
  style,
  ...rest
}) => {
  if (lines < 2) {
    return /*#__PURE__*/React.createElement(SkeletonBox, _extends({
      "data-component": "SkeletonText",
      "data-text-skeleton-size": size,
      width: "100%",
      className: clsx(className, classes.SkeletonText),
      style: merge(style, {
        maxWidth
      })
    }, rest));
  } else {
    return /*#__PURE__*/React.createElement("div", {
      "data-component": "multilineContainer",
      className: classes.SkeletonTextWrapper,
      style: merge(style, {
        maxWidth
      })
    }, Array.from({
      length: lines
    }, (_, index) => /*#__PURE__*/React.createElement(SkeletonBox, _extends({
      key: index,
      "data-component": "SkeletonText",
      "data-in-multiline": "true",
      "data-text-skeleton-size": size,
      className: clsx(className, classes.SkeletonText)
    }, rest))));
  }
};

export { SkeletonText };
